import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews, IconArrowHead } from '../../components';

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { reviews, fetchReviewsError, locale } = props;

  if (!reviews?.length) return null;
  const [showSection, setShowSection] = useState(true);

  return (
    <section className={css.section} id="listing-reviews">
      <Heading as="h2" rootClassName={css.sectionTitle} onClick={() => setShowSection(!showSection)}>
        <FormattedMessage id="ListingPage.whatPeopleSay" />
        <IconArrowHead direction={showSection ? "up" : "down"} />
      </Heading>
      {showSection && (
        <>
          {fetchReviewsError ? (
            <H2 className={css.errorText}>
              <FormattedMessage id="ListingPage.reviewsError" />
            </H2>
          ) : null}
          <Reviews reviews={reviews} locale={locale}/>
        </>
      )}
    </section>
  );
};

export default SectionReviews;
